// extracted by mini-css-extract-plugin
module.exports = {"gridFeatureItem":"feature-grid_gridFeatureItem__LTT4e","ctaLink":"feature-grid_ctaLink__dFlSq"};